import { z } from "zod";

/**
 * The service area for NWGA Connect: the four counties of the Northwest
 * Georgia region.
 *
 * This lives in `contracts` rather than in a feature because it is shared
 * vocabulary — job listings, business profiles and any future tool all filter
 * by the same set. Adding a county here makes it available everywhere at once.
 */

export const COUNTIES = [
	{ slug: "catoosa", name: "Catoosa", seat: "Ringgold" },
	{ slug: "chattooga", name: "Chattooga", seat: "Summerville" },
	{ slug: "dade", name: "Dade", seat: "Trenton" },
	{ slug: "walker", name: "Walker", seat: "LaFayette" },
] as const satisfies readonly { slug: string; name: string; seat: string }[];

export type County = (typeof COUNTIES)[number];
export type CountySlug = County["slug"];

export const COUNTY_SLUGS = COUNTIES.map(
	(county) => county.slug,
) as unknown as [CountySlug, ...CountySlug[]];

export const countySlugSchema = z.enum(COUNTY_SLUGS);

const COUNTY_BY_SLUG = new Map<string, County>(
	COUNTIES.map((county) => [county.slug, county]),
);

export function getCounty(slug: string): County | undefined {
	return COUNTY_BY_SLUG.get(slug);
}

/** "Walker County" — the form used in listing copy and page titles. */
export function countyLabel(slug: CountySlug): string {
	return `${COUNTY_BY_SLUG.get(slug)?.name ?? slug} County`;
}

export const REGION_NAME = "Northwest Georgia";
export const REGION_STATE = "GA";
